import {combineReducers} from 'redux';
import home from './home/reducer';
import review from './review/reducer';
import schedule from './schedule/reducer';
import captainDetail from './captainDetail/reducer';
import entryDetail from './entryDetail/reducer';
import base from './reducer';
import virtualEventDetail from './virtualEventDetail/reducer';
import audit from './audit/reducer';
import bowlerAudit from './audit/bowlerAudit/reducer';
import tournamentAudit from './audit/tournamentAudit/reducer';
import entryAudit from './audit/entryAudit/reducer';
import virtualEntryAudit from './audit/virtualEntryAudit/reducer';
import captainAudit from './audit/captainAudit/reducer';

const reducer = combineReducers({
  base,
  home,
  review,
  schedule,
  captainDetail,
  entryDetail,
  virtualEventDetail,
  audit,
  bowlerAudit,
  tournamentAudit,
  virtualEntryAudit,
  entryAudit,
  captainAudit
});

export default reducer;



// WEBPACK FOOTER //
// ./src/features/admin/rootReducer.js